module.exports = __webpack_public_path__ + "img/main-win-bg.93fbea31.png";